import { __rest } from "tslib";
import React from 'react';
import s from './Footer.scss';
import classNames from 'classnames';
import { FooterLogo } from './FooterLogo';
import { Box } from 'wix-style-react';
import { Brands } from '../../enums';
export var Footer = function (_a) {
    var brandProp = _a.brand, isLoggedIn = _a.isLoggedIn, CopyrightText = _a.CopyrightText, showNonBetaEditorXLogo = _a.showNonBetaEditorXLogo, ButtonLinks = __rest(_a, ["brand", "isLoggedIn", "CopyrightText", "showNonBetaEditorXLogo"]);
    var buttonLinks = Object.values(ButtonLinks);
    var brand = brandProp !== null && brandProp !== void 0 ? brandProp : Brands.WIX;
    return (isLoggedIn && (React.createElement("footer", { "data-hook": "footer" },
        React.createElement("div", { className: s.footerWrapper },
            React.createElement("div", { className: classNames(s.footer, brand) },
                React.createElement(FooterLogo, { brand: brand, showNonBetaEditorXLogo: showNonBetaEditorXLogo }),
                React.createElement("div", { className: s.footerText },
                    React.createElement("div", { className: s.footerTitle },
                        React.createElement(CopyrightText, null)),
                    React.createElement("ul", { className: s.links }, buttonLinks.map(function (ButtonLink, i) {
                        var _a;
                        var isLast = i === buttonLinks.length - 1;
                        return (React.createElement("li", { key: "buttonLink_" + i },
                            React.createElement(Box, { className: classNames(s.link, (_a = {},
                                    _a[s.marginRight] = !isLast,
                                    _a)) },
                                React.createElement(ButtonLink, null))));
                    }))))))));
};
//# sourceMappingURL=Footer.js.map